<script setup lang="ts">
import { Loading } from '@element-plus/icons-vue'

interface Props {
  loading?: boolean
}

defineProps<Props>()
</script>

<template>
  <button
    type="button"
    v-bind="$attrs"
    :disabled="loading"
    class="flex h-9 items-center justify-center rounded-4xl border border-solid px-6 hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
  >
    <div v-if="loading" class="mr-2 pt-1">
      <el-icon class="loading-icon">
        <Loading size="20" />
      </el-icon>
    </div>
    <slot />
  </button>
</template>

<style scoped>
.loading-icon {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
